import AllNodata from "../../../assets/All_NoData.svg";
const LinkNotFound = ({ errorCode }) => {
  return (
    <div className="border-radius-0 h-100 d-flex align-items-center mb-15">
      <div className="w-100 text-center">
        <div className="share_link_container">
          <div className="portlet_images mb-15">
            <img
              className="share_link_container_img"
              alt="no data"
              src={AllNodata}
            />
          </div>
          <div className="share_link_text">
            {errorCode === 602 ? "Link has expired" : "Link not found"}
          </div>
          <p className="share_link_sub_text">
            {errorCode === 602
              ? "This link has expired now, please contact the sender of the link"
              : "The link you are looking for no longer exist or has been deleted by the sender of the link."}
          </p>
        </div>
      </div>
    </div>
  );
};
export default LinkNotFound;
